import React from 'react'

const React_Assignment_2 = () => {
  return (
    <div>
      <h1>Assignment 2</h1>
    </div>
  )
}

export default React_Assignment_2
